<template>
  <router-view></router-view>
</template>

<script>
export default {
}
</script>
<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1140px !important;
  }
}

</style>
